import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    data: String
  }

  static targets = ["source"]

  async copy() {
    const text =
      (this.hasDataValue && this.dataValue) ||
      (this.hasSourceTarget && this.sourceTarget.innerText) || ""

    if (!text) return

    try {
      if (window.isSecureContext && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        this.legacyCopy(text)
      }
      // optional toast here
    } catch (_) {
      this.legacyCopy(text)
    }
  }

  legacyCopy(text) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.setAttribute("readonly", "")
    ta.style.position = "fixed"
    ta.style.top = "-9999px"
    document.body.appendChild(ta)
    ta.select()
    document.execCommand("copy")
    document.body.removeChild(ta)
  }
}
